import * as actions from 'actions/DeliveryAddressActions/locationUpdateActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { get } from 'lodash';
const defaultState = {
    asyncStatus: INIT,
    data: {
        currentPincode: ''
    }
};
export default function locationUpdateReducer(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_LOCATION_UPDATE_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case actions.GET_LOCATION_UPDATE_SUCCESS:
            const currentPincode = get(action, 'data.currentPincode', '');
            return Object.assign({}, state, {
                asyncStatus: SUCCESS,
                data: currentPincode
            });
        case actions.GET_LOCATION_UPDATE_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        default:
            return state;
    }
}
